export const AuthorizationErrorEnphaseTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-25 rounded text-gray-700">
        <h4 className="font-semibold">For Enphase Systems:</h4>
        <p className="my-4">
            Authorization errors from Enphase are most often caused by insufficient data access permissions. To
            share data for a specific solar system with an external platform like the Solar Insure Daybreak
            Platform, the company that owns the Enphase Enlighten Portal account must also be listed as the PV
            System Maintainer (instead of listing a third-party company). Make sure the company in the PV System
            Maintainer field is the same as the company owning the account (you can see the account company on
            the home dashboard). To resolve this issue:
        </p>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                Login into the <a
                    href="https://enlighten.enphaseenergy.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary-700 underline"
                >Enphase Enlighten Portal.</a>
            </li>
            <li>Locate and select the specific system that is experiencing the error to view its details.</li>
            <li>Go to the 'Settings' page for that system at the site level.</li>
            <li>Scroll down to the 'Access' section on this page.</li>
            <li>Check if the 'PV System Maintainer' field lists the name of your company.</li>
            <li>
                If the field is not populated or incorrect, update it accordingly to ensure proper access
                permissions are set for Solar Insure to connect and retrieve data. Save any changes made.
            </li>
            <li>Click on the refresh monitoring button to initiate a new attempt to pull monitoring data.</li>
        </ul>
        <p className="italic mt-4">
            If the issue persists for 10 days after making a correction to the 'PV System Maintainer'
            field, or if you were unable to find this specific issue, please contact Enphase customer support.
            There may be other permission settings on the Enphase site that Solar Insure is currently unaware
            of.
        </p>
    </div>
